import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { first, map, switchMap } from 'rxjs';
import { User } from 'src/app/interface/user';
import { DataService } from 'src/app/service/data.service';
import { environment } from 'src/environments/environment';
import { AccessProfile, AccessProfileAssignment, AccessProfileAssignmentResult } from '../models/access-profile';

const BASE_URL = `${environment.mkgoURL}/api/v1/profile`;
// BASE_URL = 'http://localhost:3000/profile'; // using json-server
@Injectable({
  providedIn: 'root'
})
export class AccessProfileService {

  private _isFromMatrix = false;


  constructor(
    private _dataService: DataService,
    private _http: HttpClient
  ) { }


  getAll() {
    return this._dataService.httpOptions(this._isFromMatrix).pipe(
      switchMap(options => this._http.get<{ profiles: AccessProfile[] }>(BASE_URL, options)),
      first(),
      map(resp => resp.profiles)
    );
  }

  getInactives() {
    return this._dataService.httpOptions(this._isFromMatrix).pipe(
      switchMap(options => this._http.get<{ profiles: AccessProfile[] }>(`${BASE_URL}/inactives`, options)),
      first(),
      map(resp => resp.profiles)
    );
  }

  get(id: string) {
    return this._dataService.httpOptions(this._isFromMatrix).pipe(
      switchMap(options => this._http.get<AccessProfile>(`${BASE_URL}/${id}`, options)),
      first()
    );
  }

  create(profile: AccessProfile) {
    return this._dataService.httpOptions(this._isFromMatrix).pipe(
      switchMap(options => this._http.post(BASE_URL, profile, options)),
      first(),
    );
  }

  update(profile: AccessProfile) {
    const apiObject = {
      name: profile.name,
      modules: profile.modules
    }
    return this._dataService.httpOptions(this._isFromMatrix).pipe(
      switchMap(options => this._http.put<{ id: string }>(`${BASE_URL}/${profile._id}`, apiObject, options)),
      first(),
    );
  }

  /** Disables (`disable`) or re-enables (`active`) a profile. */
  inactiveOrActive(id: string, action: 'disable' | 'active') {
    return this._dataService.httpOptions(this._isFromMatrix).pipe(
      switchMap(options => this._http.put<{ id: string }>(`${BASE_URL}/${id}/${action}`, {}, options)),
      first(),
    );
  }

  /** The users currently assigned to the profile, across every company of the group. */
  getAssignedUsers(id: string) {
    return this._dataService.httpOptions(this._isFromMatrix).pipe(
      switchMap(options => this._http.get<{ users: User[] }>(`${BASE_URL}/${id}/users`, options)),
      first(),
      map(resp => resp.users)
    );
  }

  /** Moves users off the profile in a single call; `profile: null` leaves the user without one. */
  updateAssignments(id: string, assignments: AccessProfileAssignment[]) {
    return this._dataService.httpOptions(this._isFromMatrix).pipe(
      switchMap(options => this._http.put<{ results: AccessProfileAssignmentResult[] }>(`${BASE_URL}/${id}/assignments`, { assignments }, options)),
      first(),
      map(resp => resp.results)
    );
  }


}
